module.exports = __webpack_public_path__ + "static/media/img1-en-mobile.ded9b2a7.png";